/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useEffect, useState, useRef } from 'react';
import { useCurrentDoc } from 'docz';
import * as styles from './styles';
import { NavLink } from '../NavLink';
import { ChevronDown } from '../Icons';
import { jsx as ___EmotionJSX } from "@emotion/core";
export const NavGroup = _ref => {
  let {
    item,
    sidebarRef
  } = _ref;
  const currentDoc = useCurrentDoc();
  const currentDocRef = useRef();
  const {
    name,
    menu
  } = item;
  const {
    0: subheadingsVisible,
    1: setShowsubheadings
  } = useState(currentDoc.menu === name);
  const toggleSubheadings = () => setShowsubheadings(!subheadingsVisible);
  useEffect(() => {
    if (sidebarRef.current && currentDocRef.current) {
      sidebarRef.current.scrollTo(0, currentDocRef.current.offsetTop);
    }
  }, []);
  return jsx("div", {
    sx: styles.wrapper,
    "data-testid": "nav-group"
  }, jsx("div", {
    sx: styles.title,
    onClick: toggleSubheadings
  }, item.name, jsx(ChevronDown, {
    sx: styles.chevron({
      active: subheadingsVisible
    })
  })), jsx("div", {
    sx: styles.sublinkWrapper,
    "data-testid": "nav-group-links"
  }, menu && subheadingsVisible && menu.map(menu => {
    if (currentDoc.route === menu.route) {
      return jsx(NavLink, {
        key: menu.id,
        item: menu,
        ref: currentDocRef
      }, menu.name);
    }
    return jsx(NavLink, {
      key: menu.id,
      item: menu
    }, menu.name);
  })));
};
if (typeof NavGroup !== 'undefined' && NavGroup && NavGroup === Object(NavGroup) && Object.isExtensible(NavGroup) && !Object.prototype.hasOwnProperty.call(NavGroup, '__filemeta')) {
  Object.defineProperty(NavGroup, '__filemeta', {
    configurable: true,
    value: {
      name: "NavGroup",
      filename: "node_modules/gatsby-theme-docz/src/components/NavGroup/index.js"
    }
  });
}